<template>
  <ul :class="bodyClass" class="timeline__container">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'Timeline',
  props: {
    bodyClass: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.timeline__container {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  max-width: 800px;
  min-width: 600px;
  margin: 0 auto;
}
</style>
